import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemCapDonViHanhChinh} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {Input, TextArea} from 'components/tt-forms/common';
import {MasterLayout} from 'layout';

class CapDonViHanhChinh extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ma: '',
      isValid: true,
      ten: '',
      moTa: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }
  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.ten = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getCapDonViHanhChinh.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.capDonViHanhChinhs,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if(this.checkValidate())
    {
      let params = {
        ma: this.state.ma.trim(),
        ten: this.state.ten.trim(),
        moTa: this.state.moTa.trim()
      };
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        this.props.danhMuc.updateCapDonViHanhChinh({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postCapDonViHanhChinh('',params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if(categoryId){
        this.setState({buttonLoading: true});
        this.props.danhMuc.deleteCapDonViHanhChinh({id: categoryId}).then(res => {
          this.getListData();
          Toastr(msg.delCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(function (error) {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      addType: 0,
      ma: '',
      ten: '',
      moTa: '',
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:2,
      ma: item.ma,
      ten: item.ten,
      moTa: item.moTa,
      isValid: true,
      categoryId: item.capDonViHanhChinhId
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Cấp đơn vị hành chính</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('CAPDONVIHANHCHINH_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <Search parents={this}/>
            <DataTable
              header = {header.administrativeunits}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent= {this}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemCapDonViHanhChinh/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa cấp đơn vị hành chính' : 'Thêm mới cấp đơn vị hành chính'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <Input className="" label="Mã" value={this.state.ma} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ma')} bindValidator={this} channel="danhMuc"/>
              <Input className="" label="Tên" value={this.state.ten} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ten')} bindValidator={this} channel="danhMuc"/>
              <TextArea label="Mô tả" rows={5} maxLength={255} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className=''/>

            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}
CapDonViHanhChinh.defaultProps = {
  validators: {}
}
function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(CapDonViHanhChinh);



// WEBPACK FOOTER //
// ./src/components/modules/category/CapDonViHanhChinh.jsx